import React from "react";

import { Avatar, AvatarImage, AvatarFallback } from "../ui/avatar";
import { cn } from "../../lib/utils";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { canalDoTicket } from "../../helpers/canalDoTicket";
import { esperaDoTicket } from "../../helpers/tempoDeEspera";

// Quem está com o atendimento, em português. Duas linhas bastam: o nome do
// contato e uma frase curta — nada de rótulos técnicos para decifrar.
const TicketInfo = ({ contact, ticket, onClick }) => {
  const initials = (contact?.name || "?")
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  const canal = canalDoTicket(ticket);
  const CanalIcone = canal.icone;
  const espera = esperaDoTicket(ticket);

  return (
    <button
      type="button"
      onClick={onClick}
      title="Ver dados do contato"
      className="flex min-w-0 flex-1 items-center gap-2.5 rounded-lg py-1 pl-1 pr-2.5 text-left transition-colors hover:bg-accent"
    >
      <span className="relative shrink-0">
        <Avatar className="h-10 w-10">
          <AvatarImage src={contact?.profilePicUrl} alt={contact?.name} />
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <span
          title={canal.rotulo}
          aria-label={`Canal: ${canal.rotulo}`}
          className={cn(
            "absolute -bottom-0.5 -right-0.5 flex h-4 w-4 items-center justify-center rounded-full ring-2 ring-background",
            canal.classe,
          )}
        >
          <CanalIcone className="h-2.5 w-2.5" />
        </span>
      </span>

      <div className="min-w-0">
        <p className="flex min-w-0 items-baseline gap-1.5 truncate text-[15px] font-semibold leading-tight">
          <span className="truncate">{contact?.name}</span>
          <span className="shrink-0 font-normal text-muted-foreground">
            #{ticket.id}
          </span>
        </p>

        <p className="mt-0.5 flex min-w-0 items-center gap-1.5 truncate text-xs text-muted-foreground">
          {ticket.user?.name ? (
            <span className="truncate">Atribuído à: {ticket.user.name}</span>
          ) : (
            <span className="truncate">Ninguém assumiu ainda</span>
          )}

          {/* A espera é o único ponto de cor da linha: é o que aperta. */}
          {espera && (
            <>
              <span className="text-muted-foreground/50">·</span>
              <span className={cn("shrink-0 font-medium", espera.classe)}>
                {ticket.status === "pending"
                  ? "aguardando há "
                  : "sem resposta há "}
                {espera.rotulo}
              </span>
            </>
          )}
        </p>
      </div>
    </button>
  );
};

// A linha de etiquetas ganha faixa própria abaixo do cabeçalho, sempre
// visível: dentro do cabeçalho ela disputava espaço com o nome e sumia nas
// telas menores.
export const TicketTagsBar = ({ ticket, children }) => {
  const salvar = async (tagIds) => {
    try {
      await api.put(`/tickets/${ticket.id}/tags`, { tagIds });
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div className="flex items-center gap-2 border-b bg-background px-3 py-1.5">
      {React.cloneElement(children, {
        selectedTagIds: ticket.tags ? ticket.tags.map((t) => t.id) : [],
        onChange: salvar,
      })}
    </div>
  );
};

export default TicketInfo;
